/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './video-stream.stache';
import deviceUtil from 'scripts/utils/device';
import can from 'can';

Component.extend({
    tag: 'video-stream',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            activeCard: {
                Type: can.Map,
                value: null,
                set(card) {
                    if (card && card.identifier) {
                        return card;
                    }
                    return null;
                },
            },
            cards: {
                Type: can.List,
                Value: [],
            },
            initialCard: {
                Type: can.Map,
                Value: null,
            },
            dtmTrack: {
                type: 'boolean',
            },
            dtmVideoLocation: {
                type: 'string',
            },
        },
        playNextVideo() {
            const cards = this.attr('cards');
            const activeCard = this.attr('activeCard');
            if (cards && cards.length) {
                let cardIndex = null;
                cards.each((card, index) => {
                    if (card.identifier === activeCard.identifier) {
                        cardIndex = index;
                        return false;
                    }
                });
                if (cardIndex !== null) {
                    cards[cardIndex + 1]
                        ? this.attr('activeCard', cards[cardIndex + 1])
                        : null;
                } else {
                    this.attr('activeCard', cards[0]);
                }
            }
        },
    },
    init() {
        this.viewModel.attr(
            'isMobile',
            deviceUtil.isMobile && !deviceUtil.isTablet,
        );
        this.viewModel.attr('cards').on('change', (event) => {
            const cards = event.target;
            const activeCard = this.viewModel.attr('activeCard');
            if (cards && cards.length && !activeCard) {
                this.viewModel.attr('initialCard', cards[0]);
            }
            return cards;
        });
    },
    events: {
        '.s-btn-play click'() {
            this.viewModel.attr('dtmTrack', true);
            this.viewModel.attr(
                'activeCard',
                this.viewModel.attr('initialCard'),
            );
            if (this.viewModel.attr('isMobile')) {
                this.element
                    .find('.s-video-active brightcove-video')
                    .viewModel()
                    .playWithSoundCheck();
            }
        },
    },
});
